import { createGlobalStyle } from 'styled-components';
import 'react-toastify/dist/ReactToastify.css';

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    outline: 0;
  }
  body {
    background: #FFF;
    color: #FFF;
    -webkit-font-smoothing: antialiased;
  }
  .swal2-container{
    z-index: 1071 !important;
  }
`;
